<style lang="scss" scoped>
.az-app-login {
  height: 100%;
  // background-color: #eef0f5;
  background-color: #222;

  .login-card {
    width: 850px;
    height: 390px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .login-logo {
      width: 403px;
      height: 100%;
      background: url("./img/login.jpg") no-repeat 0 -66px;

      .logo {
        display: block;
        width: 145px;
        margin-left: 37px;
        margin-top: 39px;
      }

      .bg_words {
        color: #fff;
        text-align: center;

        // width: 222px;
        // margin-left: 28px;
        // height

        margin-top: 377px;

        .title {
          font-size: 24px;
          margin-bottom: 24px;
        }

        .content {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }

    .login-form {
      width: 435px;
      padding: 0 71px;
      box-sizing: border-box;

      .model-icon {
        position: absolute;
        right: 10px;
        font-size: 20px;
        top: 10px;
        cursor: pointer;

        &:hover {
          color: $color-primary;
        }

        &:active {
          opacity: 0.5;
        }
      }

      .title {
        color: #313540;
        font-size: 20px;
        margin-top: 156px;
        margin-bottom: 20px;
        font-weight: 550;
        // text-align: center;
      }

      .form_item {
        margin-bottom: 10px;

        &.verification {
          padding-right: 120px;
          position: relative;

          .img_view {
            position: absolute;
            right: 0;
            top: 0;
            width: 110px;
            height: 38px;
            background-color: #fff;
            // background-color: pink;
            border-radius: 2px;
            overflow: hidden;
            cursor: pointer;
          }
        }
      }

      .btn {
        button.login_btn {
          // font-size:14px;
          width: 100%;
          margin-top: 18px;
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }

          &:active {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="az-app-login">
    <div class="login-card clearfix">
      <div class="az-lft login-logo">
        <img src="./img/logo.svg" alt="vk_logo" class="logo">
      </div>
      <div class="az-rt login-form">
        <i v-if="!iS_PRO" class="model-icon el-icon-sugar"
          @click="SHOW_LOGIN  = !SHOW_LOGIN"></i>
        <p class="title">Hello，欢迎登录业财系统~!</p>
        <p class="btn" v-if="SHOW_LOGIN">
          <el-button type="primary" class="login_btn" @click="loginClickHandler">使用飞书登录
          </el-button>
        </p>
        <div v-else>
          <div>
            <el-select v-model="selectUserOpenId" filterable placeholder="请选择要登录的用户"
              style="width: 100%;">
              <el-option
                v-for="item in users"
                :key="item.open_id"
                :label="item.name"
                :value="item.open_id">
                <span style="float: left;">{{ item.name }}</span>
                <span
                  style="float: right; color: #8492a6; font-size: 13px;">{{ item.city }}</span>
              </el-option>
            </el-select>
            <div class="btn">
              <el-button type="primary" class="login_btn"
                @click="testLoginClickHandler()">立即登录
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { extract422Message } from '../../utils/utils';
import { getNologinUsers } from '@/api/base'

export default {
  name: 'login',
  data() {
    return {
      iS_PRO: process.env.VUE_APP_CLIENT_ENV == 'pro',
      SHOW_LOGIN: true,
      ENV: process.env,
      selectUserOpenId: '',
      btnIsLoading: false,
      users: []
    }
  },
  methods: {
    loginClickHandler() {
      const appid = 'cli_a87d8525873c9013'
      const callback_url = encodeURI(`${this.ENV.VUE_APP_BASE_URL}/logined`)
      location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${appid}&redirect_uri=${callback_url}`
    },
    testLoginClickHandler() {
      if (!this.selectUserOpenId) return this.$message.error('请先选择用户')
      if (this.btnIsLoading) return
      this.btnIsLoading = true
      this.$store.dispatch('Login', {
        open_id: this.selectUserOpenId
      }).then(res => {
        if (res.code == 422) throw new Error(extract422Message(res.data));
        if (res.code != 0) throw new Error(res.message);
        this.$message({
          message: '登录成功,即将跳转',
          type: 'success'
        })
        setTimeout(() => {
          this.$router.push('/approval').catch(err => {
            console.log(err)
          })
        }, 1000)
      }).catch(err => {
        this.$message({
          message: err.response && err.response.data ? err.response.data.message : err.message,
          type: 'error',
          dangerouslyUseHTMLString: true
        });
      }).finally(item => {
        this.btnIsLoading = false
      })
    },

    async initPage() {
      if (this.IS_PRO) return
      const res = await getNologinUsers()
      if (res.code != 0 || !Array.isArray(res.data)) return
      this.users = res.data
    }
  },
  created() {
    console.log('process.env', process.env);
    // build:test时不执行后面代码
    this.initPage()
  },

};
</script>
